import React, { useLayoutEffect, useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import StructuredTextDefault from '../../Blocks/StructuredTextDefault/StructuredTextDefault';

import './styles.scss';

const Alert = () => {
  const data = useStaticQuery(graphql`
    query TopMessage {
      datoCmsConfiguration {
        showTopAlert
        message {
          value
          blocks
          links {
            __typename
            id: originalId
            slug
            model {
              apiKey
            }
          }
        }
      }
    }
  `);

  const [toggleTopMessage, setToggleTopMessage] = useState(data.datoCmsConfiguration.showTopAlert || false);
  const [showTopMessageAccordingSession, setShowTopMessageAccordingSession] = useState(true);

  useLayoutEffect(() => {
    if (sessionStorage.getItem('show_top_message')) {
      setShowTopMessageAccordingSession(sessionStorage.getItem('show_top_message') == 'true');
    }
  }, []);

  const handleToggleTopMessage = () => {
    setToggleTopMessage((toggleMessage) => {
      sessionStorage.setItem('show_top_message', !toggleMessage);
      return !toggleMessage;
    });
  };

  if (!toggleTopMessage || !showTopMessageAccordingSession) {
    return null;
  }

  const { message } = data.datoCmsConfiguration;

  return (
    <div className="alert-component" data-datocms-noindex>
      <div className="container">
        <div className="message">
          <StructuredTextDefault content={message} />
        </div>
      </div>

      <button className="close-btn" onClick={handleToggleTopMessage} aria-label="Close message">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
          <path
            d="M10.0059 20.0041C8.02721 20.0053 6.09267 19.4194 4.4471 18.3207C2.80153 17.222 1.5189 15.6598 0.761538 13.8318C0.00417799 12.0038 -0.193865 9.99221 0.192473 8.05163C0.578811 6.11105 1.53216 4.32869 2.93187 2.93015C4.80801 1.05401 7.35261 0 10.0059 0C12.6591 0 15.2037 1.05401 17.0799 2.93015C18.956 4.80629 20.01 7.35088 20.01 10.0041C20.01 12.6574 18.956 15.202 17.0799 17.0781C16.1528 18.0094 15.0502 18.7475 13.836 19.2498C12.6217 19.752 11.3199 20.0084 10.0059 20.0041ZM2.00587 10.1761C2.0286 12.2903 2.88732 14.3095 4.39435 15.7924C5.90138 17.2753 7.93416 18.1014 10.0484 18.09C12.1627 18.0787 14.1864 17.2308 15.6774 15.7318C17.1684 14.2327 18.0054 12.2044 18.0054 10.0901C18.0054 7.97586 17.1684 5.94755 15.6774 4.44852C14.1864 2.94948 12.1627 2.10163 10.0484 2.09026C7.93416 2.0789 5.90138 2.90495 4.39435 4.38787C2.88732 5.87079 2.0286 7.88999 2.00587 10.0041V10.1761ZM7.41487 14.0041L6.00487 12.5941L8.59587 10.0041L6.00587 7.41415L7.41587 6.00415L10.0059 8.59415L12.5959 6.00415L14.0059 7.41415L11.4159 10.0041L14.0059 12.5941L12.5979 14.0041L10.0059 11.4141L7.41587 14.0041H7.41487Z"
            fill="white"
          />
        </svg>
      </button>
    </div>
  );
};

export default Alert;
